import React, { useState, useEffect } from "react";
import "./Profile.css";
import { Button } from "react-bootstrap";
import UpdatePassword from "../../Presentation/UpdatePassword/UpdatePassword";
import LanguageSelector from "../../Presentation/LanguageSelector/LanguageSelector";
import Clarifications from "../../Presentation/Clarifications/Clarifications";
import GenerateBarcode from "../../Presentation/GenerateBarcode/GenerateBarcode";
import ProfileClimateModule from "../ProfileClimateModule/ProfileClimateModule";
import ProfileSettingRow from "./ProfileSettingRow";

let langData = require("../../../Data/language.json");

export default function Profile(props) {
  const [expanded, setExpanded] = useState("");

  const [expandedClimate, setExpandedClimate] = useState(false);

  let videoIcon = require("../../../Images/Icons/settingsVideoIcon.svg");
  let passwordIcon = require("../../../Images/Icons/settingsPasswordIcon.svg");
  let languageIcon = require("../../../Images/Icons/settingsFlagIcon.svg");
  let barcodeIcon = require("../../../Images/Icons/barcode.svg");
  let clarificationIcon = require("../../../Images/Icons/questionCircle.svg");

  var lastTouchEnd = 0;

  useEffect(() => {
    document.addEventListener("touchEnd", (evt) => disableDoubleTap(evt));
    return () => {
      window.removeEventListener("touchEnd", disableDoubleTap);
    };
  }, []);

  const disableDoubleTap = (evt) => {
    const now = new Date().getTime();
    if (now - lastTouchEnd <= 300) {
      evt.preventDefault();
    }
    lastTouchEnd = now;
  };

  return (
    <div className="paper">
      <div id="profileContainer">
        <img
          className="profileIcon"
          src={require("../../../Images/Icons/profileIcon.svg")}
          alt="profileIcon"
        ></img>
        <h4 id="profileLoggedInText">
          {langData[props.language].profile.loggedInStatus}
        </h4>
        <h6 id="profileEmailText">{props.email}</h6>
      </div>

      <div className="container-fluid settings">
        <hr />
        <ProfileClimateModule
          language={props.language}
          inventory={props.inventory}
          langData={langData}
          expandedClimate={expandedClimate}
          setExpandedClimate={setExpandedClimate}
        />
        <div className="container-fluid col-12 helperTextWrapper">
          <p className="settingHelperText">
            {langData[props.language].profile.instructionText}
          </p>
        </div>
        <hr />
        <ProfileSettingRow
          icon={languageIcon}
          title={langData[props.language].profile.language}
          expandHeight="100px"
          expanded={expanded === "language"}
          setExpanded={setExpanded}
          id="language"
        >
          <LanguageSelector
            language={props.language}
            updateLanguage={props.updateLanguage}
          />
        </ProfileSettingRow>

        <hr />
        <ProfileSettingRow
          icon={passwordIcon}
          title={langData[props.language].profile.changePassword}
          expandHeight="190px"
          expanded={expanded === "password"}
          setExpanded={setExpanded}
          id="password"
        >
          <UpdatePassword
            language={props.language}
            updatePassword={props.updatePassword}
            errorText={props.errorText}
          />
        </ProfileSettingRow>

        <hr />
        <ProfileSettingRow
          icon={clarificationIcon}
          title={langData[props.language].profile.clarificationTitle}
          expandHeight="190px"
          expanded={expanded === "clarification"}
          setExpanded={setExpanded}
          id="clarification"
        >
          <Clarifications language={props.language} />
        </ProfileSettingRow>

        <hr />
        <ProfileSettingRow
          icon={videoIcon}
          title={langData[props.language].profile.instructionVideo}
          expandHeight="240px"
          expanded={expanded === "video"}
          setExpanded={setExpanded}
          id="video"
        >
          <iframe
            title="GreenCobraVideo"
            width="300"
            height="200"
            allowFullScreen="allowfullscreen"
            frameBorder="0"
            src="https://www.youtube.com/embed/lgr9I4g9zco"
          />
        </ProfileSettingRow>
        <hr />
        <ProfileSettingRow
          icon={barcodeIcon}
          title={langData[props.language].profile.scannerTitle}
          expandHeight="30px"
          expanded={expanded === "barcode"}
          setExpanded={setExpanded}
          id="barcode"
        >
          <GenerateBarcode
            username={props.username}
            expandedBarcode={expanded === "barcode"}
            close={() => setExpanded("")}
            language={props.language}
          />
        </ProfileSettingRow>

        <hr />
      </div>

      <Button
        className="logoutButton"
        variant="light"
        onClick={() => props.OnLogoutClick()}
      >
        {langData[props.language].profile.logOutBtn}
      </Button>
    </div>
  );
}
